export const MAX_DECIMAL_PLACES = 20;
export const SCIENTIFIC_NOTATION_FORMATTER = Intl.NumberFormat('en-US', {
  style: 'decimal',
  useGrouping: true,
  notation: 'scientific',
  maximumSignificantDigits: 3,
});

export function shouldAbbreviate(abbreviate?: boolean) {
  return abbreviate !== false;
}

export function hasDecimalPlaces(decimal_places?: number) {
  return typeof decimal_places === 'number' && !isNaN(decimal_places);
}

// Avoids maximumFractionDigits out-of-range error.
// Allowed values are 0 to 20.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#maximumfractiondigits
export function limitDecimalPlaces(num?: number) {
  if (!num) return num;

  if (num < 0) {
    num = 0;
  } else if (num > MAX_DECIMAL_PLACES) {
    num = MAX_DECIMAL_PLACES;
  }

  return num;
}
